export enum LoanFrequency {
	BI_WEEKLY = 'biWeekly',
	MONTHLY = 'monthly',
	SEMI_MONTHLY = 'semiMonthly',
	WEEKLY = 'weekly'
}
